import Network from 'infrastructure/js/modules/network';

export function fetchSensorProviders() {
  return Network.get('sensor-providers');
}

export function createSensorProviderConfig(query) {
  return Network.post('sensor-provider-settings', query);
}

export function updateSensorProviderConfig(query) {
  let settingId = query.settingId;
  delete query.settingId;
  return Network.put(`sensor-provider-settings/${settingId}`, query);
}

export function deleteSensorProviderConfig(ids) {
  return Network.delete('sensor-provider-settings', { ids });
}

export function setDefaultConfig(id) {
  return Network.post(`sensor-provider-settings/${id}/default`);
}

export function fetchSensorProviderConfigsGrid(query) {
  return Network.post('sensor-provider-settings/items', query);
}

export function fetchSensorProviderConfigs(query) {
  return Network.post('sensor-provider-settings/search/items', query);
}

export function fetchSensorProviderConfig(id) {
  return Network.get(`sensor-provider-settings/${id}`);
}

export function fetchEventProfiles({ provider, ...rest }) {
  return Network.post(`sensor-provider-settings/${provider}/event-profiles`, rest);
}
